import SsciEditStudentPage from "./SsciEditStudentPage";

export default SsciEditStudentPage